import type { IconProps } from './index';
import type { ReactElement } from 'react';

import { Svg } from './styles';
import { colors } from '../styles';

const QuickViewIcon = ({ color = colors.BLACK, hoverColor }: IconProps): ReactElement => (
  <Svg
    width="16"
    height="16"
    fill="none"
    $hoverColor={hoverColor}
    role="presentation"
    aria-hidden="true"
  >
    <path
      fill={color}
      d="M14.937 4.172A1.257 1.257 0 0 0 14 3.75h-2.76a3.25 3.25 0 0 0-6.48 0H2.006A1.25 1.25 0 0 0 .759 5.147l.89 7.5a1.254 1.254 0 0 0 1.247 1.103h10.208a1.254 1.254 0 0 0 1.247-1.103l.89-7.5a1.252 1.252 0 0 0-.304-.975ZM8 2.25a1.75 1.75 0 0 1 1.732 1.5H6.268A1.75 1.75 0 0 1 8 2.25Zm4.887 10H3.113l-.832-7H4.75V6.5a.75.75 0 0 0 1.5 0V5.25h3.5V6.5a.75.75 0 0 0 1.5 0V5.25h2.469l-.832 7Z"
    />
  </Svg>
);

export default QuickViewIcon;
